// extracted by mini-css-extract-plugin
export default {"link":"vI_UaHPOxJaqQCLDHHVd"};